import React, { useMemo } from 'react';

/**
 * Hook to manage button tooltips based on disabling conditions
 * @param rules Array of rules containing condition and message
 * @returns The tooltip message if any rule's condition is true, undefined otherwise
 */
const useConditionTooltip = (rules) => {
  return useMemo(() => {
    const activeRule = rules.find((rule) => rule.condition);
    return activeRule?.message;
  }, [rules]);
};

export default useConditionTooltip;
